import { popupStore } from '@pascal/pascal-core/shared/core/store';
import { loadingStore } from '@pascal/pascal-core';

import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';
import { roundTimeStore } from '../store/roundTimeStore';

import { worker } from '../index';
import { liveConnection } from '../core';
import { gameLiveConnection } from './GameConnection';

let timeOutId;

class GameService {
  onGetInitialStateResult() {
    loadingStore.updateLoading({ isGameInitialLoaded: true });
  }

  handleDoBetResult() {}

  handleDoBetResultValidation() {}

  handleRoundStart() {}

  handleResultReport() {}

  handleRoundFin() {}

  handleBetsClosed() {}

  socketRecursiveReconnecting() {
    try {
      liveConnection
        .restartGameConnection()
        .then((connectionData) => {
          liveConnection.connectionInitCallback(connectionData);
          clearTimeout(timeOutId);
        })
        .catch(() => {
          timeOutId = setTimeout(() => {
            this.socketRecursiveReconnecting();
          }, 4000);
        });
    } catch (err) {
      // popupStore.open({ name: PopUps.ConnectionError });
      popupStore.onConnectionError(true);
      popupStore.toggleReconnect(true);
    }
  }

  handleReconnecting(error) {
    if (error && error.message) {
      // eslint-disable-next-line
      popupStore.open({ name: PopUps.Reconnect });
      popupStore.toggleReconnect(true);
    } else {
      GameService.ReconnectCount += 1;
      popupStore.open({ name: PopUps.Reconnect });
      popupStore.toggleReconnect(true);
    }
  }

  handleReconnected() {
    GameService.ReconnectCount = 0;
    if (popupStore.popupName !== PopUps.ConnectionError) {
      gameLiveConnection.sendGameGetInitialState(false).then(() => {});
    }
  }

  handleConnectionError() {
    if (GameService.ReconnectCount) {
      // popupStore.open({ name: PopUps.ConnectionError });
      popupStore.onConnectionError(true);
    }
  }

  countDown({ data: time }) {
    roundTimeStore.setTime(time);
  }

  sendWorker(timerValue) {
    if (timerValue) {
      worker.addEventListener('message', this.countDown);
      worker.postMessage(timerValue);
    } else {
      worker.removeEventListener('message', this.countDown);
    }
  }

  handleResetDataInitial() {}
}

export const gameService = new GameService();
